export const MenuSadmin = [
    {
        menutitle: "Control panel",
        Items: [
            { path: `${process.env.PUBLIC_URL}/controlpanel/concessionaire/viewconcessionaire`, icon: "file", title: "Concessionaires", type: "link" },
            { path: `${process.env.PUBLIC_URL}/controlpanel/users`, icon: "user", title: "Users", type: "link" },
            { path: `${process.env.PUBLIC_URL}/controlpanel/log`, icon: "project", title: "Logs", type: "link" },
            { path: `${process.env.PUBLIC_URL}/controlpanel/errorlog`, icon: "button", title: "Error Logs", type: "link" },
            { path: `${process.env.PUBLIC_URL}/controlpanel/deletionLog`, icon: "others", title: "Deletion Logs", type: "link" },
        ],
    },
];
